import * as url from 'url';
import { checkEmailExistsInFirebase } from './firebase';
import { containsOnlyWhiteSpaces } from './string';

export const constructEmail = (
  volcanoServiceId: string,
  email: string,
): string => {
  const redirectLink = url.resolve(
    process.env.REACT_APP_GRAPHQL_ENDPOINT as string,
    `/launch_service/${volcanoServiceId}`,
  );

  return `mailto:${email}?subject=MVIPS Servicio ${volcanoServiceId}&body=Hello,%0D%0A%0D%0AYou can check service ${volcanoServiceId} info clicking this link ${redirectLink}.%0D%0A%0D%0AHave a pleasant trip,%0D%0A%0D%0AMVIPS Team%0D%0A%0D%0A%0D%0AHola,%0D%0A%0D%0APuede consultar la información del servicio ${volcanoServiceId} haciendo click en este link ${redirectLink}.%0D%0A%0D%0ALe deseamos un buen viaje,%0D%0A%0D%0AEl equipo de MVIPS`;
};

export const openEmailClient = (recipientEmail: string) => {
  window.open(`mailto:${recipientEmail}?subject=MVIPS`);
};

export const sendEmail = (mailToText: string) => {
  window.open(mailToText);
};

export const validateEmail = async (
  email: string,
  {
    isRequired,
    checkAgainstFirebase,
  }: {
    isRequired: {
      enabled: boolean;
      message?: string;
    };
    checkAgainstFirebase: {
      enabled: boolean;
      message?: string;
      previousEmail?: string;
      newEmail?: string;
    };
  },
): Promise<string | undefined> => {
  if (isRequired.enabled && (!email || containsOnlyWhiteSpaces(email))) {
    return isRequired.message || 'Por favor, introduce un correo electrónico';
  }
  if (!isRequired.enabled && (!email || containsOnlyWhiteSpaces(email))) return;

  const valid = /.+@.+\..+/.test(email);

  checkAgainstFirebase.newEmail = email;

  if (!valid) {
    return 'Por favor, utiliza un correo electrónico válido';
  } else {
    if (
      checkAgainstFirebase.enabled &&
      checkAgainstFirebase.previousEmail !== checkAgainstFirebase.newEmail &&
      checkAgainstFirebase.newEmail !== undefined
    ) {
      const emailExists = await checkEmailExistsInFirebase(email);
      if (emailExists) {
        return (
          checkAgainstFirebase.message || 'Ya existe un usuario con ese email'
        );
      }
    }
    return;
  }
};
